const sysBranchOrg = [{
  desc: '组织机构列表接口',
  options: {
    url: '/sysBranchOrg/queryOrgInfoAndStatistics',
    method: 'post'
  }
}, {
  desc: '组织/机构新增或修改接口',
  options: {
    url: '/sysBranchOrg/addOrUpdateSysBranchOrg',
    method: 'post'
  }
}, {
  desc: '从车险初始化机构组织用户人员数据',
  options: {
    url: '/sysBranchOrg/initAllInfoFromSaaS',
    method: 'get'
  }
}, {
  desc: '设置机构奖励负责人',
  options: {
    url: '/sysBranchOrg/updateChargeCustomer',
    method: 'post',
    argsParams: true
  }
}, {
  desc: '解除机构奖励负责人',
  options: {
    url: '/sysBranchOrg/removeChargeCustomer',
    method: 'post',
    argsParams: true
  }
}, {
  desc: '组织机构标签新增或修改接口',
  options: {
    url: '/sysBranchOrg/addOrUpdateSysOrgLabel',
    method: 'post'
  }
}, {
  desc: '组织机构标签类型接口',
  options: {
    url: '/sysBranchOrg/querySysOrgLabelType',
    method: 'post'
  }
}, {
  desc: '组织机构标签接口',
  options: {
    url: '/sysBranchOrg/querySysOrgLabel',
    method: 'post'
  }
}]
export default sysBranchOrg



// WEBPACK FOOTER //
// ./src/api/sysBranchOrg.js